
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { DATE_FORMAT, DATE_TIME_FORMAT, TIME_FORMAT } from './constants';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, DATE_FORMAT);
  }
}

@Pipe({
    name: 'timeFormat'
  })
  export class TimeFormatPipe extends DatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
      return super.transform(value, TIME_FORMAT);
    }
}
  
@Pipe({
    name: 'dateTimeFormat'
  })
  export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
      return super.transform(value, DATE_TIME_FORMAT);
    }
  }

  @Pipe({
    name: 'sentenceWithUnderscoreTitleCase'
  })
  export class SentenceWithUnderscoreTitleCase extends TitleCasePipe implements PipeTransform {
    transform(value: any, args?: any): any {
      value = value.split('_').join(' ')
      return super.transform(value);
    }
  }

  @Pipe({
    name: 'secondsToHms'
  })
  export class SecondsToHmsPipe implements PipeTransform {

    transform(value: number): string {

      value = Number(value)
      if (isNaN(value)) {
        return 'Invalid Input';
      }
      if(value == 0){
        return "0 hrs"
      }
      let isNegativeNumber = value < 0
      if(isNegativeNumber){
        value = value * -1
      }

      const hours = Math.floor(value / 3600);
      const minutes = Math.floor((value % 3600) / 60);
      const seconds = value % 60;
      
      var hDisplay = hours > 0 ? hours + (hours == 1 ? " hr " : " hrs ") : "";
      var mDisplay = minutes > 0 ? minutes + (minutes == 1 ? " min " : " mins ") : "";
      var sDisplay = seconds > 0 ? seconds + (seconds == 1 ? " sec" : " secs") : "";

      let timeString = hDisplay + mDisplay + sDisplay;
      if(isNegativeNumber){
        timeString = '-' + timeString
      }
     
      return timeString;
  }
}
